import React from 'react'
import request from 'superagent';
import Detail from './Detail'
import DetailMiHaplo from './DetailMiHaplo'
import DetailYHaplo from './DetailYHaplo'
import DetailSkinDietSports from './DetailSkinDietSports'
import {timeoutRedirect} from './Util'
import {URL_DETAIL} from '../constants/Url'
// import TagManager from 'react-gtm-module'
// import {getTagManagerArgs} from './Util';

export default class DetailSelect extends React.Component {

  constructor(props) {
    super(props)
    this.state = {
      detail: null,
      kit: props.kit,
      unit_id: props.unit_id,
      gender: props.gender
    }

    this.setWrapperRef = this.setWrapperRef.bind(this);
    this.handleClickOutside = this.handleClickOutside.bind(this);
    this.handleSwitchModal = this.handleSwitchModal.bind(this)
  }

  handleClickOpen(){
    const { handleModalOpen } = this.props
    handleModalOpen()
  }

  handleClickClose(){
    const { handleModalClose } = this.props
    handleModalClose()
  }

  handleSwitchModal(){
    let current_path = window.location.pathname;
    if (current_path === '/detail') {
      this.handleClickOpen();
    } else {
      this.handleClickClose();
    }
  }

  componentDidMount() {
    document.addEventListener('click', this.handleClickOutside);
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    // URL直打ちされたらTOPに戻す
    if (!this.props.location.state || !this.props.location.state.referer) {
      this.props.history.push({ pathname: '/', state: { referer: null, url: '/' }})
    }
    // ブラウザバックを押されたら、詳細画面のポップアップを表示切り替えを操作する
    window.addEventListener("popstate", this.handleSwitchModal)
    // そもそも詳細画面のポップアップを表示させる時でなかった場合もTOPに戻す
    if (!this.props.show) {
      this.props.history.goBack();
    }
  }

  componentWillUnmount() {
    document.removeEventListener('click', this.handleClickOutside);
  }

  setWrapperRef(node) {
    this.wrapperRef = node;
  }


  handleClickOutside(event) {
    if (this.wrapperRef && !this.wrapperRef.contains(event.target)) {
      // handleClickClose()を呼ぶと2度呼ばれて、トップ画面まで戻るので直接history.goBackを呼んだ
      window.addEventListener("popstate", this.handleSwitchModal)
      this.props.history.goBack();
    }
  }

  componentWillMount() {
    request
      .get(URL_DETAIL(this.props.token, this.props.kit, this.props.unit_id))
      .set('Content-Type', 'application/json')
      .end((err, res) => {
        if (err) {
          console.log('error')
          return;
        }

        if (!res.body.result) {
          timeoutRedirect()
        }

        this.setState({detail: res.body.result})
      });
  }

  render() {
    const {show} = this.props

    if (!this.state.detail) {
      return (
        <div className="c-modal" aria-activedescendant={show === true ? 'true' : 'false'}>
          <div>{/* データなし */}</div>
        </div>
      );
    }

    return (
      <div>
      <div className="c-modal" aria-activedescendant={show === true ? 'true' : 'false'}>
        <div className="c-modal__panel"  ref={this.setWrapperRef}>
          <div className="c-modal__header">
            <span onClick={this.handleClickClose.bind(this)}>×</span>
          </div>
          <div id="c-modal__content" className="c-modal__content">
            {/* {TagManager.initialize(getTagManagerArgs("/detail/" + this.state.unit_id))} */}
            {this.selectDetail(this.state.unit_id, this.state.detail, this.state.gender)}
          </div>
          <div className="c-modal__bottom">
            <button className="c-btn c-btn-default--flat decline" onClick={this.handleClickClose.bind(this)}>閉じる</button>
          </div>
        </div>

      </div>
      <div className="c-modal__overlay"></div>
      </div>
      )
  }

  selectDetail(unitId, detail, gender) {

    switch (unitId) {
      case 569:
        return (<DetailYHaplo detail={detail}/>);
      case 949:
        return (<DetailMiHaplo detail={detail}/>);
      case 521:
      case 550: //sports（筋肉の発達）を追加
      case 947:
      case 948:
        return (<DetailSkinDietSports detail={detail} gender={gender} openAffiliateResult={(detail, subtypes) => { (this.props.openAffiliateResult(detail, subtypes)); }} affiliate_agreed={this.props.affiliate_agreed}/>);
      default:
        return (<Detail detail={detail}/>);
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/DetailSelect.js